import sortBy from 'lodash/sortBy';

export default class {
  constructor(IntegrationService, PersonaCollection, Utils, $uibModalInstance, integration) {
    'ngInject';

    Object.assign(this, {
      IntegrationService,
      PersonaCollection,
      Utils,
      $uibModalInstance,
      integration,
    });

    this.init();
  }

  async init() {
    this.users = sortBy([...this.PersonaCollection.users], ['name', 'lastname']);
    this.invalidFields = new Set();

    this.options = [
      {
        label: "It's a new employee",
        value: 'create',
        sticky: true,
      },
      ...this.users.map((user) => ({
        label: `${user.name} ${user.lastname}`,
        value: user.id,
        icon: user.avatar,
        sub: user.position,
        extra: user.location,
      })),
    ];

    this.loading = true;
    try {
      const usersToMap = await this.IntegrationService.getUsersToMap(this.integration);
      this.usersToMap = usersToMap.filter((item) => !item.coreId);

      if (!this.usersToMap.length) {
        this.$uibModalInstance.close();
        return;
      }

      this.usersToMap.forEach((userToMap) => {
        const coreUserMatch = this.PersonaCollection.users.find(
          (loc) => loc.name.toLowerCase() === userToMap.name.toLowerCase()
        );
        if (coreUserMatch) {
          userToMap.coreId = coreUserMatch.id;
        } else {
          userToMap.coreId = 'create';
        }

        userToMap.onChange = (item) => {
          if (item) {
            this.invalidFields.delete(userToMap);
          } else {
            this.invalidFields.add(userToMap);
          }

          userToMap.coreId = item;
        };
      });
    } finally {
      this.loading = false;
    }
  }

  async submit() {
    if (this.invalidFields.size) {
      return;
    }

    const payload = this.usersToMap
      .filter((item) => item.coreId !== undefined)
      .reduce((agg, item) => ((agg[item.id] = item.coreId), agg), {});

    await this.IntegrationService.sync(this.integration, { user_mapping: payload });

    this.$uibModalInstance.close();
  }
}
